/* eslint-disable */
export default {
  forward: 'Doorverbinden',
  cancel: 'Annuleren',
  customNumber: 'Aangepast nummer',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"customNumber"@#@ @source: @#@"Custom number"@#@
